'use es6';

import Raven from 'raven-js';
import colr from '../vendor/colr';

// Shown in place of a color that `colr` can't parse
const FallbackColor = '#ffffff';

// Unparseable colors are reported once per page load, to find consumers that
// pass values like unresolved HubL expressions.
const reportedColors = new Set();

/** Hex parser that returns null instead of throwing when unparseable. */
export const parseHex = hex => {
  try {
    return colr.fromHex(hex);
  } catch (_unused) {
    if (!reportedColors.has(hex)) {
      reportedColors.add(hex);
      Raven.captureException(new Error('Unable to parse color as hex'), {
        level: 'warning',
        extra: {
          color: String(hex)
        }
      });
    }
    return null;
  }
};

/** Hex parser that parses a fallback color instead of throwing when unparseable. */
export const parseHexOrFallback = hex => {
  var _parseHex;
  return (_parseHex = parseHex(hex)) !== null && _parseHex !== void 0 ? _parseHex : colr.fromHex(FallbackColor);
};

/** Returns `hex` if it is parseable, or a fallback hex color. */
export const getHexOrFallback = hex => parseHex(hex) ? hex : FallbackColor;